import React, { Component } from "react";
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { getEnv } from "../../env";
import FileUploader from "../../03-components/FileUploader";
import "./style.css";

export default class EventImageDialog extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.editMode = props.options && props.options.editMode;
    this.state = {
      path: (props.options && props.options.value.path) || "",
      type: (props.options && props.options.value.type) || "",
      name: (props.options && props.options.value.name) || "",
      data: (props.options && props.options.value.data) || "",
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleOK = this.handleOK.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  handleInput(field) {
    return (e) => {
      this.setState({ [field]: e.target.value });
    };
  }

  handleFile(field) {
    return (e) => {
      this.setState({ [field]: e });
    };
  }

  handleClose() {
    this.props.onClose && this.props.onClose();
  }

  handleOK() {
    this.props.onOK &&
      this.props.onOK(this.props.options, {
        path: this.state.path,
        type: this.state.type,
        name: this.state.name,
        data: this.state.data,
      });
  }

  render() {
    return (
      <Modal isOpen={true}>
        <ModalHeader>{`${this.editMode ? "Edit" : "Add"} image`}</ModalHeader>
        <ModalBody>
          <div className="con-imagedialog">
            <div className="d-flex flex-column margin-bottom-20px">
              <div className="label">Image type</div>
              <div>
                <Input
                  value={this.state.type}
                  disabled={this.editMode}
                  type="select"
                  onChange={this.handleInput("type")}
                >
                  <option value="">Select an image type</option>
                  <option>brands</option>
                  <option>gallery</option>
                  <option>promo</option>
                </Input>
              </div>
            </div>
            <div className="d-flex flex-column margin-bottom-20px">
              <div className="label">Image name</div>
              <div>
                <Input
                  disabled={this.editMode}
                  onChange={this.handleInput("name")}
                  type="text"
                  value={this.state.name}
                />
              </div>
            </div>
            <div className="d-flex flex-column margin-bottom-20px">
              <div className="label">Image file</div>
              <div>
                {this.editMode && !this.state.image && (
                  <img
                    src={
                      getEnv("S3_ASSETS_BUCKET") +
                      "/" +
                      this.state.path +
                      "?" +
                      Date.now()
                    }
                    alt="no-data"
                  />
                )}
                <FileUploader onChange={({ uri }) => this.handleFile("path")(uri)} />
              </div>
            </div>
            <div className="d-flex flex-column margin-bottom-20px">
              <div className="label">Image data</div>
              <div>
                <Input
                  onChange={this.handleInput("data")}
                  type="textarea"
                  value={this.state.data}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="margin-right-15px" onClick={this.handleClose}>
            {"Cancel"}
          </Button>
          <Button
            disabled={!this.state.type || !this.state.name}
            color="primary"
            onClick={this.handleOK}
          >
            {`${this.editMode ? "Save" : "Add"}`}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/04-containers/ImageDialog/index.js